import { useState } from "react";
import "./Galerija.css";
import Thumbnails from "./Thumbnails.jsx";
import ImageFetcher from "../../components/ImageFetcher.jsx";

const Galerija = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const showImage = (image) => {
    setSelectedImage(image);
  };

  return (
    <div
      id="galerija"
      className="galerija-section"
      style={{
        backgroundImage: `url(https://res.cloudinary.com/dvuaaubys/image/upload/v1764855160/5_nhntwk.jpg)`,
      }}
    >
      <div className="originals">
        {selectedImage ? (
          <ImageFetcher image={selectedImage} name="original-photo" />
        ) : (
          <ImageFetcher image="16_xzo0u3" name="original-photo" />
        )}
      </div>
      <Thumbnails showImage={showImage} />
    </div>
  );
};

export default Galerija;
